module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.5eae1f7.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@intelipost-modules/secure-ng/dist/fonts/glyphicons-halflings-regular.woff
// module id = wTO5
// module chunks = 72